<main-header seeker="true"></main-header>
<div class="container">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<main-footer></main-footer>